// react
import { createContext, Dispatch, SetStateAction } from 'react';

// types
import { Contract, Pagination, Project } from '../../../@types';

export interface ContextContractsProps {
	contracts: Contract[];
	isLoadingContracts: boolean;
	paginationContracts: Pagination | null;
	refetchContracts: () => void;
	setContracts: Dispatch<SetStateAction<Contract[]>>;
}

export const ContextContracts = createContext<ContextContractsProps>({
	contracts: [],
	isLoadingContracts: false,
	paginationContracts: null,
	refetchContracts: () => {
		console.log('REFETCH CONTRACTS');
	},
	setContracts: () => {
		console.log('SET CONTRACTS');
	},
});

export interface ContextProjectsProps {
	hasProjectV2: boolean;
	isLoadingProjects: boolean;
	projects: Project[];
	refetchProjects: () => void;
	setProjects: Dispatch<SetStateAction<Project[]>>;
}

export const ContextProjects = createContext<ContextProjectsProps>({
	hasProjectV2: false,
	isLoadingProjects: false,
	projects: [],
	refetchProjects: () => {
		console.log('REFETCH PROJECTS');
	},
	setProjects: () => {
		console.log('SET PROJECTS');
	},
});
